function operate (guards, to, from, lastNext, i) {
	let guard = guards[i]
	if (guards.length === i + 1) {
		guard(to, from, lastNext)
	} else {
		guard(to, from, function (nextArg) {
			switch (typeof (nextArg)) {
				case 'undefined':
					operate(guards, to, from, lastNext, i + 1);
					break;
				case 'object':
					lastNext(nextArg);
					break;
				case 'boolean':
					lastNext(nextArg);
					break;
				case 'string':
					lastNext(nextArg);
					break;
			}
		})
	}
}

export default function(listOfGuards) {
	return function(to, from, next) {
		operate(listOfGuards, to, from, next, 0)
	}
}